import { useCallback, useState } from 'react'
import { HallType } from '@weblite/ts-action/hall'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import {
  HallCallTime,
  HallCallType,
  showChooseHallCallTimeDialog,
} from '$comp/modals/create-hall-call/choose-call-time'
import { showChooseChannelCallDialog } from '$comp/modals/create-hall-call/choose-call-type/choose-channel-call'
import { callService } from '$logic/call'
import { useRoomAttribute } from '$logic/room'
import { useClientUserPermissions } from '$logic/subscription/react-hook'
import { showChooseGroupCallDialog } from '$comp/modals/create-hall-call/choose-call-type/choose-group-call'

interface Props {
  roomId: string
  hallType: HallType
}
export function useStartCall({ roomId, hallType }: Props) {
  const [startingCall, setStartingCall] = useState(false)
  const call = useRoomAttribute('call', roomId)
  const userPermissions = useClientUserPermissions(roomId)
  const canStartCall = userPermissions?.isAdmin || userPermissions?.isOwner

  const openChooseCallTimeDialog = useCallback(
    async (callType: HallCallType, onBack: () => unknown) => {
      const {
        time,
        shouldSendNotificationMessage,
        title,
        shouldStartNow,
      } = (await showChooseHallCallTimeDialog({
        callType,
        onBack,
        hallType,
      })) as HallCallTime
      setStartingCall(true)
      if (shouldStartNow) {
        callService.startCall(roomId, hallType, callType, title).finally(() => {
          setStartingCall(false)
        })
      } else
        callService
          .scheduleCall({
            roomId,
            roomType: hallType,
            callType,
            callTime: time,
            name: title,
            shouldSendNotification: shouldSendNotificationMessage,
          })
          .finally(() => {
            setStartingCall(false)
          })
    },
    [roomId, hallType],
  )

  const openChooseCallDialog = useCallback(async () => {
    const callType =
      hallType === 'CHANNEL'
        ? await showChooseChannelCallDialog()
        : await showChooseGroupCallDialog()

    openChooseCallTimeDialog(callType, async () => {
      await closeCurrentModal()
      openChooseCallDialog()
    })
  }, [hallType, openChooseCallTimeDialog])

  return { openChooseCallDialog, startingCall, call, canStartCall }
}
